// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"537beb43","163":"2a4daca9","307":"95c386e1","353":"4559d7b9","487":"26325fd6","561":"2e8fb2e0","632":"c9ad7a72","810":"fc68527f"}[chunkId] + ".css";
};